import React, { useEffect } from "react";

import { SettingBody } from "./styled";
import {
  UserPreferenceSetting,
  useUserPreferenceSetting,
  UserState,
  LoginSelector,
} from "store/data/User";
import { FormattedMessage } from "react-intl";
import { useRecoilValue } from "recoil";
import { getUserPreference } from "api/common";
import { isSuccess } from "util/Common";
import SpotSetting from "./SpotSeting";

interface SettingDialogProps {
  theme: string;
  onClose?: () => void;
}

const SettingDialog: React.FC<SettingDialogProps> = (props) => {
  const [, setUserPreferenceSetting] = useUserPreferenceSetting();
  const user = useRecoilValue(UserState);
  const { theme, onClose } = props;
  const isLogin = useRecoilValue(LoginSelector);

  useEffect(() => {
    return () => {
      if (isLogin) {
        getUserPreference().then((res) => {
          const { code } = res || {};
          const data = res?.data || {};
          if (isSuccess(code)) {
            setUserPreferenceSetting(data as UserPreferenceSetting);
          }
        });
      }
    };
  }, []);

  return (
    <div className={"px-[24px] py-[22px]"}>
      <div
        className={
          "font-space-grotesk flex justify-between items-center text-primaryText text-[16px] pb-[20px] leading-[22px] border-b border-[var(--cointr-color-line2)]"
        }
      >
        <div className="font-space-grotesk text-[16px]">
          <FormattedMessage
            id={"user_preference.confirm_sub_title"}
            defaultMessage={"Preference Settings"}
          />
        </div>
        <div className={"cursor-pointer"} onClick={() => onClose()}>
          <i className={"iconfont icon-ic_insight_close"} />
        </div>
      </div>
      <SettingBody>
        {/* 登陆部分*/}

        {/* 现货部分 组件内设计未登陆、登陆逻辑 */}
        <SpotSetting theme={theme} userId={user.userId}></SpotSetting>
      </SettingBody>
    </div>
  );
};

export default SettingDialog;
